









































































import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
export default class ZonePicto extends Vue {

    @Prop({default: ''})
    private zoneCode: string;
}
